import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
// ui
import { Button } from 'src/@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'src/@/components/ui/table';
import { Switch } from 'src/@/components/ui/switch';
import { Badge } from 'src/@/components/ui/badge';
// components
import Iconify from 'src/components/Iconify';
import ModalProdutos from './ModalProdutos';
import ModalImportarProdutos from './ModalImportarProdutos';
// actions
import {
    v2_actionListarProdutos,
    v2_actionCriarProduto,
    v2_actionEditarProduto,
    v2_actionDeletarProduto,
    v2_actionListarCategorias,
    v2_actionCriarCategoria,
    v2_actionEditarCategoria,
    v2_actionDeletarCategoria,
    v2_actionVerificarSkuExiste,
    v2_actionContarProdutos,
} from 'src/actions/v2/cadastro/v2_actionProdutos';

// ----------------------------------------------------------------------

export default function ProdutosComponent({ user, cliente }) {
    const { enqueueSnackbar } = useSnackbar();
    const [openModal, setOpenModal] = useState(false);
    const [openModalImport, setOpenModalImport] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [dataProduct, setDataProduct] = useState({});
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [productLimit, setProductLimit] = useState({ count: 0, limit: 100 });

    const fetchData = async () => {
        if (cliente?._id) {
            try {
                const [prods, cats, countRes] = await Promise.all([
                    v2_actionListarProdutos(cliente._id),
                    v2_actionListarCategorias(cliente._id),
                    v2_actionContarProdutos(cliente._id)
                ]);
                setProducts(prods.data.data || prods.data || []);
                setCategories(cats.data.data || cats.data || []);
                if (countRes.data?.data) {
                    setProductLimit(countRes.data.data);
                }
            } catch (error) {
                console.error(error);
                enqueueSnackbar('Erro ao carregar dados.', { variant: 'error' });
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, [cliente]);

    const handleOpenModal = async () => {
        try {
            if (cliente?._id) {
                const countResponse = await v2_actionContarProdutos(cliente._id);
                const { count, limit, available } = countResponse.data?.data || {};
                if (available !== undefined && available <= 0) {
                    enqueueSnackbar(`Limite de ${limit} produtos atingido. Exclua produtos existentes para criar novos.`, { variant: 'warning' });
                    return;
                }
            }
        } catch (error) {
            console.error('Erro ao verificar limite de produtos:', error);
        }
        setOpenModal(true);
        setIsEdit(false);
        setDataProduct({ sequence: [], tags: [], attributes: [] });
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setIsEdit(false);
        setDataProduct({});
    };

    const handleEdit = (product) => {
        setDataProduct(product);
        setIsEdit(true);
        setOpenModal(true);
    };

    const handleDelete = async (id) => {
        try {
            await v2_actionDeletarProduto(id);
            setProducts(products.filter((p) => p._id !== id));
            enqueueSnackbar('Produto excluído com sucesso!', { variant: 'success' });
        } catch (error) {
            enqueueSnackbar('Erro ao excluir produto', { variant: 'error' });
        }
    };

    const handleSubmit = async () => {
        try {
            // Verificar se SKU já existe
            if (dataProduct?.sku) {
                const checkResponse = await v2_actionVerificarSkuExiste(cliente._id, dataProduct.sku);
                if (checkResponse.data?.data?.exists) {
                    enqueueSnackbar('Já existe um produto com este SKU/Código. Por favor, use outro.', { variant: 'warning' });
                    return;
                }
            }

            const payload = { ...dataProduct, cliente: cliente };
            const response = await v2_actionCriarProduto(payload);
            if (!response.error) {
                setProducts([...products, response.data.data || response.data]);
                enqueueSnackbar('Produto criado com sucesso!', { variant: 'success' });
                handleCloseModal();
            }
        } catch (error) {
            enqueueSnackbar('Erro ao criar produto', { variant: 'error' });
        }
    };

    const handleEditSubmit = async () => {
        try {
            // Verificar se SKU já existe (excluindo o produto atual)
            if (dataProduct?.sku) {
                const checkResponse = await v2_actionVerificarSkuExiste(cliente._id, dataProduct.sku, dataProduct._id);
                if (checkResponse.data?.data?.exists) {
                    enqueueSnackbar('Já existe outro produto com este SKU/Código. Por favor, use outro.', { variant: 'warning' });
                    return;
                }
            }

            const response = await v2_actionEditarProduto(dataProduct._id, dataProduct);
            if (!response.error) {
                const newProducts = products.map((p) => (p._id === dataProduct._id ? response.data.data || response.data : p));
                setProducts(newProducts);
                enqueueSnackbar('Produto editado com sucesso!', { variant: 'success' });
                handleCloseModal();
            }
        } catch (error) {
            enqueueSnackbar('Erro ao editar produto', { variant: 'error' });
        }
    };

    const changeName = (e) => {
        setDataProduct({ ...dataProduct, name: e.target.value });
    };

    const changeSku = (e) => {
        setDataProduct({ ...dataProduct, sku: e.target.value });
    };

    const changeRef = (e) => {
        setDataProduct({ ...dataProduct, ref: e.target.value });
    };

    const changeDescription = (e) => {
        setDataProduct({ ...dataProduct, description: e.target.value });
    };

    const changePrice = (e) => {
        setDataProduct({ ...dataProduct, price: e.target.value });
    };

    const changePriceSale = (e) => {
        setDataProduct({ ...dataProduct, priceSale: e.target.value });
    };

    const changeSale = (checked) => {
        setDataProduct({ ...dataProduct, sale: checked });
    };

    const changeStock = (e) => {
        setDataProduct({ ...dataProduct, stock: e.target.value });
    };

    const changeSequence = (newSequence) => {
        setDataProduct({ ...dataProduct, sequence: newSequence });
    };

    const changeCategory = (categoryId) => {
        setDataProduct({ ...dataProduct, category: categoryId });
    };

    const changeImage = (imageUrl) => {
        setDataProduct({ ...dataProduct, image: imageUrl });
    };

    const changeTags = (newTags) => {
        setDataProduct({ ...dataProduct, tags: newTags });
    };

    const changeAttributes = (newAttributes) => {
        setDataProduct({ ...dataProduct, attributes: newAttributes });
    };

    const changeLink = (e) => {
        setDataProduct({ ...dataProduct, link: e.target.value });
    };

    const handleToggleStatus = async (id, currentStatus) => {
        try {
            const newStatus = !currentStatus;
            const response = await v2_actionEditarProduto(id, { status: newStatus });
            if (!response.error) {
                setProducts((prev) => prev.map((p) => (p._id === id ? { ...p, status: newStatus } : p)));
                enqueueSnackbar('Status atualizado com sucesso!', { variant: 'success' });
            }
        } catch (error) {
            console.error(error);
            enqueueSnackbar('Erro ao atualizar status', { variant: 'error' });
        }
    };

    const handleCategoryActions = {
        create: async (name) => {
            try {
                const res = await v2_actionCriarCategoria({ ownerId: cliente._id, name });
                if (!res.error) setCategories([...categories, res.data.data || res.data]);
                return res.data.data || res.data;
            } catch (e) {
                console.error(e);
            }
        },
        update: async (id, name) => {
            try {
                const res = await v2_actionEditarCategoria(id, { name });
                if (!res.error) {
                    setCategories(categories.map((c) => (c._id === id ? res.data.data || res.data : c)));
                }
            } catch (e) {
                console.error(e);
            }
        },
        delete: async (id) => {
            try {
                await v2_actionDeletarCategoria(id);
                setCategories(categories.filter((c) => c._id !== id));
            } catch (e) {
                console.error(e);
            }
        },
    };

    const getCategoryName = (categoryData) => {
        // If category is populated object
        if (typeof categoryData === 'object' && categoryData?.name) return categoryData.name;
        // If category is just an ID string, find in categories array
        if (categoryData) {
            const catId = typeof categoryData === 'object' ? categoryData._id : categoryData;
            const found = categories.find((c) => c._id === catId || c._id?.toString() === catId?.toString());
            if (found) return found.name;
        }
        return '-';
    };

    return (
        <div className="flex flex-col h-full w-full gap-6 p-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div>
                    <div className="flex items-center gap-3">
                        <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Produtos</h1>
                        <Badge
                            variant="outline"
                            className={`font-medium ${productLimit.count >= productLimit.limit ? 'bg-red-50 text-red-600 border-red-200' : 'bg-violet-50 text-violet-600 border-violet-200'}`}
                        >
                            {productLimit.count} / {productLimit.limit}
                        </Badge>
                    </div>
                    <p className="text-sm text-gray-500 mt-1">Gerencie seus produtos e configure as sequências de entrega automática.</p>
                </div>
                <div className="flex gap-2">
                    <Button
                        onClick={() => setOpenModalImport(true)}
                        variant="outline"
                        className="flex items-center gap-2 px-4 py-2.5 bg-white text-gray-700 font-medium rounded-xl transition-all shadow-sm border border-gray-200 hover:bg-gray-50"
                    >
                        <Iconify icon="solar:file-download-bold" className="w-5 h-5 text-gray-500" />
                        Importar CSV
                    </Button>
                    <Button
                        onClick={handleOpenModal}
                        className="flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95"
                    >
                        <Iconify icon="solar:add-circle-bold" className="w-5 h-5" />
                        Novo Produto
                    </Button>
                </div>
            </div>

            {products.length === 0 ? (
                <div className="flex flex-col items-center justify-center p-12 bg-white rounded-xl border border-gray-100 border-dashed text-center">
                    <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4 text-gray-400">
                        <Iconify icon="solar:box-minimalistic-bold-duotone" className="w-8 h-8" />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Nenhum produto encontrado</h3>
                    <p className="text-gray-500 max-w-sm mb-6">Cadastre seu primeiro produto para começar a vender e automatizar entregas.</p>
                    <Button variant="ghost" className="text-[#7C3AED] font-medium hover:underline text-sm" onClick={handleOpenModal}>
                        Criar meu primeiro produto
                    </Button>
                </div>
            ) : (
                <div className="rounded-xl border border-gray-100 bg-white overflow-hidden shadow-sm">
                    <Table>
                        <TableHeader className="bg-gray-50">
                            <TableRow>
                                <TableHead className="w-[80px]">Img</TableHead>
                                <TableHead className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Nome</TableHead>
                                <TableHead className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Categoria</TableHead>
                                <TableHead className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Tags</TableHead>
                                <TableHead className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Preço</TableHead>
                                <TableHead className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Estoque</TableHead>
                                <TableHead className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Status</TableHead>
                                <TableHead className="text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">Ações</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {products.map((product) => (
                                <TableRow key={product._id} className="hover:bg-gray-50 transition-colors">
                                    <TableCell>
                                        <div className="w-10 h-10 rounded-lg bg-gray-100 overflow-hidden flex items-center justify-center">
                                            {product.image ? (
                                                <img src={product.image} alt="" className="w-full h-full object-cover" />
                                            ) : (
                                                <Iconify icon="solar:gallery-bold-duotone" className="text-gray-400 w-5 h-5" />
                                            )}
                                        </div>
                                    </TableCell>
                                    <TableCell className="font-medium text-gray-900">
                                        <div className="flex flex-col">
                                            <span>{product.name}</span>
                                            <div className="flex gap-2 text-[10px] text-gray-500 font-mono">
                                                {product.sku && <span>SKU: {product.sku}</span>}
                                                {product.ref && <span>REF: {product.ref}</span>}
                                            </div>
                                            <span className="text-[10px] text-gray-400 truncate max-w-[150px]">{product.description}</span>
                                        </div>
                                    </TableCell>
                                    <TableCell>
                                        <Badge variant="outline" className="font-normal text-gray-600 bg-gray-50 border-gray-200">
                                            {getCategoryName(product.category)}
                                        </Badge>
                                    </TableCell>
                                    <TableCell>
                                        <div className="flex flex-wrap gap-1 max-w-[150px]">
                                            {product.tags?.slice(0, 2).map((tag, i) => (
                                                <span key={i} className="text-[10px] px-1.5 py-0.5 rounded bg-violet-100 text-violet-700">
                                                    {tag}
                                                </span>
                                            ))}
                                            {product.tags?.length > 2 && <span className="text-[10px] text-gray-400">+{product.tags.length - 2}</span>}
                                        </div>
                                    </TableCell>
                                    <TableCell className="text-gray-600">
                                        <div className="flex flex-col">
                                            <span>R$ {product.price}</span>
                                            {product.priceSale && <span className="text-xs text-green-600 font-medium">Promo: R$ {product.priceSale}</span>}
                                        </div>
                                    </TableCell>
                                    <TableCell className="text-gray-600">{product.stock}</TableCell>
                                    <TableCell>
                                        <Switch
                                            checked={product.status !== false}
                                            onCheckedChange={() => handleToggleStatus(product._id, product.status !== false)}
                                        />
                                    </TableCell>
                                    <TableCell className="text-right">
                                        <div className="flex justify-end gap-2">
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                className="h-8 w-8 p-0 text-blue-600 hover:text-blue-700 hover:bg-blue-50"
                                                onClick={() => handleEdit(product)}
                                            >
                                                <Iconify icon="solar:pen-bold" className="w-4 h-4" />
                                            </Button>
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                className="h-8 w-8 p-0 text-red-600 hover:text-red-700 hover:bg-red-50"
                                                onClick={() => handleDelete(product._id)}
                                            >
                                                <Iconify icon="solar:trash-bin-trash-bold" className="w-4 h-4" />
                                            </Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            )}

            <ModalProdutos
                open={openModal}
                onClose={handleCloseModal}
                onSubmit={handleSubmit}
                onEdit={handleEditSubmit}
                isEdit={isEdit}
                dataProduct={dataProduct}
                changeName={changeName}
                changeSku={changeSku}
                changeRef={changeRef}
                changeDescription={changeDescription}
                changePrice={changePrice}
                changePriceSale={changePriceSale}
                changeSale={changeSale}
                changeStock={changeStock}
                changeSequence={changeSequence}
                user={user}
                cliente={cliente}
                changeCategory={changeCategory}
                changeImage={changeImage}
                changeTags={changeTags}
                changeAttributes={changeAttributes}
                changeLink={changeLink}
                categories={categories}
                categoryActions={handleCategoryActions}
            />

            <ModalImportarProdutos
                open={openModalImport}
                onClose={() => setOpenModalImport(false)}
                cliente={cliente}
                onSuccess={() => {
                    fetchData();
                }}
            />
        </div>
    );
}